import HistoryIcon from '@mui/icons-material/History';
import Button from 'components/Button';
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { fetchTranscripts } from 'store/action/transcription';
import { useAppDispatch, useAppState } from 'store/configureStore';
import { Heading } from './styles';

const ConsultationHeading: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { featureFlags } = useAppState();

  useEffect(() => {
    if (featureFlags.SUMMARISER_SAVE_TRANSCRIPT_ENABLED) {
      fetchTranscripts(dispatch);
    }
  }, [dispatch, featureFlags.SUMMARISER_SAVE_TRANSCRIPT_ENABLED]);

  const handlePastConsultationsClick = () => {
    navigate('/past-consultations');
  };

  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
      <Heading>Summarise consultation</Heading>
      {featureFlags.SUMMARISER_SAVE_TRANSCRIPT_ENABLED && (
        <Button
          id="past-consultations-button"
          onClick={handlePastConsultationsClick}
          buttonText="Past consultations"
          icon={<HistoryIcon />}
          iconPosition="left"
          state="secondary"
          disabled={false}
        />
      )}
    </div>
  );
};

export default ConsultationHeading;
